export function flattenMenu(menu: any[]): any[][] {
    return menu.flatMap(item => {
        const { children, ...rest } = item;
        return [rest, ...flattenMenu(children)];
    });
}